import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 text-silver-dark py-12 border-t border-silver/20" data-id="element-96" data-mp="32wd2qgad7ltj">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-97" data-mp="3gg1025qei1yp">
        <h2 className="text-white font-bold text-xl mb-4" data-id="element-98" data-mp="32oe09vx92bb6">
          🔍 MEGAPACK CRIMINALÍSTICA LISTO™
        </h2>

        <p className="text-silver mb-6" data-id="element-99" data-mp="36qhg0wqyc229">
          Hecho por especialistas, para docentes de Criminalística, Ciencias
          Forenses y formación policial de toda Argentina.
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-100" data-mp="38zawx2kd95j">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-silver-light transition-colors" data-id="element-101" data-mp="3lem0a55nkln5">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" aria-hidden="true" data-id="element-102" data-mp="29z6x2jmuoxjl">
            ·
          </span>
          <span data-id="element-103" data-mp="2eya0y0r3gxpz">📱 @centralpack.ar</span>
        </div>

        <div className="text-xs text-silver-dark/80 border-t border-silver/15 pt-8 space-y-3" data-id="element-104" data-mp="2ezuvvrhbmiod">
          <p data-id="element-105" data-mp="3labt60db0esh">
            © MEGAPACK CRIMINALÍSTICA LISTO™ 2026 — Todos los derechos reservados.
          </p>
          <p className="italic text-silver" data-id="element-106" data-mp="3gca6z6kkzzcs">
            🇦🇷🔍 "La próxima clase que des, podés entrar al aula sabiendo que
            Argentina fue el primer país del mundo en resolver un crimen con
            huellas dactilares. Eso fue en 1892. Lo que viene en 2026 es todavía
            más grande."
          </p>
        </div>
      </div>
    </footer>;
}